import { IReduxStore } from 'Redux/Store/IReduxStore';

export const isLoggedIn = (store: IReduxStore) =>
    !!store.user.authentication.accessToken;

